/** Что главная помнит между показами — как состояние модуля эталона: кадр слайдера (S.i), открытый вопрос
    (BotCore.faq, FAQ_OPEN; первый раз — S.open = 0) и прокрутка главной до поиска (S.hqTop: её возвращает очистка поля,
    и после возврата в раздел на выдаче поиска тоже). Живёт до перезагрузки страницы: через уход в каталог,
    экран создания и другой раздел (bot-studio.js: S, mount/unmount; docs/APP-SPEC-3-studio.md:169).
    Пока кадр не менялся, slide нет — тогда кадр задаёт вход (флаг хэша slideN). */
export const studioHomeMemory: { slide?: number; faq: number | null; hqTop?: number | null } = { faq: 0 };

/** Только для тестов: вернуть первый показ */
export function resetStudioHomeMemory() {
  delete studioHomeMemory.slide;
  delete studioHomeMemory.hqTop;
  studioHomeMemory.faq = 0;
}
